// src/pages/Keyword.jsx - Complete File with Horizontal Navigation
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import SearchNavigation from '../components/SearchNavigation';
import ApiService from '../services/apiService';

const Keyword = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [isListening, setIsListening] = useState(false);
  const [recognition, setRecognition] = useState(null);

  // State for radio button options
  const [searchType, setSearchType] = useState('all');
  const [nearWordsDistance, setNearWordsDistance] = useState('5');
  const [sortOrder, setSortOrder] = useState('most-relevant');
  const [searchIn, setSearchIn] = useState('B');
  const [searchInCourt, setSearchInCourt] = useState('ALL');

  useEffect(() => {
    const storedKeyword = localStorage.getItem('SearchHKeyword');
    if (storedKeyword) {
      setSearchQuery(storedKeyword);
    }
  }, []);

  const handleSearch = async (e) => {
    e.preventDefault();

    if (!searchQuery.trim() || isLoading) return;

    setIsLoading(true);
    setError('');

    try {
      console.log('Starting Search process...');
      console.log('Query:', searchQuery);
      console.log('Search Type:', searchType);
      console.log('Sort Order:', sortOrder);
      console.log('Search In:', searchIn);

      const searchOptions = {
        pageSize: 25,
        page: 1,
        sortBy: sortOrder === 'most-relevant' ? 'rele' :
        sortOrder === 'most-recent' ? 'year' :
        sortOrder === 'most-referred' ? 'rele' : 'year',
        sortOrder: sortOrder === 'oldest' ? 'asc' : 'desc',
        searchType: searchType,
        searchIn: searchIn,
        nearWordsDistance: searchType === 'near' ? parseInt(nearWordsDistance) : undefined
      };
      
      const apiResponse = await ApiService.searchKeyword({
        query: searchQuery, 
        type: searchType, 
        querySlop: nearWordsDistance, 
        searchIn: searchIn, 
        mainkeys: [searchInCourt]
      }, searchOptions);

      const searchResults = apiResponse.hits || [];
      const totalCount = apiResponse.total || 0;

      console.log(`📊 Processing ${searchResults.length} results from total ${totalCount}`);

      if (searchResults.length === 0) {
        setError('No results found for your search query. Try different keywords.');
        setIsLoading(false);
        return;
      }

      const resultsData = {
        results: apiResponse.hits || [],
        totalCount: apiResponse.total || 0,
        query: searchQuery,
        searchType: 'Keyword Search',
        timestamp: new Date().toISOString(),
        courtsList: apiResponse.courtsList || [],
        yearList: apiResponse.yearList || [],
        searchData: {
          query: searchQuery,
          searchType,
          sortOrder,
          searchIn,
          nearWordsDistance,
          mainkeys: [searchInCourt]
        }
      };

      console.log('💾 Storing results with API data:', resultsData);
      localStorage.setItem('searchResults', JSON.stringify(resultsData));
      localStorage.setItem('SearchHKeyword', searchQuery);
      console.log('🚀 Navigating to results page...');
      navigate('/results');

    } catch (error) {
      console.error('❌ Keyword Search failed:', error);
      setError(error.message || 'Keyword Search failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if ('webkitSpeechRecognition' in window || 'SpeechRecognition' in window) {
      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      const recognitionInstance = new SpeechRecognition();

      recognitionInstance.continuous = true;
      recognitionInstance.interimResults = true;
      recognitionInstance.lang = 'en-US';

      recognitionInstance.onstart = () => {
        setIsListening(true);
      };

      recognitionInstance.onresult = (event) => {
        let finalTranscript = '';

        for (let i = event.resultIndex; i < event.results.length; i++) {
          if (event.results[i].isFinal) {
            finalTranscript += event.results[i][0].transcript;
          }
        }

        if (finalTranscript) {
          setSearchQuery(prev => prev + finalTranscript);
        }
      };

      recognitionInstance.onerror = (event) => {
        console.error('Speech recognition error:', event.error);
        setIsListening(false);

        if (event.error === 'not-allowed') {
          setError('Microphone access denied. Please allow microphone access and try again.');
        } else if (event.error === 'no-speech') {
          setError('No speech detected. Please try speaking again.');
        } else {
          setError('Speech recognition error. Please try again.');
        }
      };

      recognitionInstance.onend = () => {
        setIsListening(false);
      };

      setRecognition(recognitionInstance);
    } else {
      console.warn('Speech recognition not supported in this browser');
    }
  }, []);

  const handleVoiceSearch = () => {
    if (!recognition) {
      setError('Speech recognition is not supported in your browser. Please try Chrome, Safari, or Edge.');
      return;
    }

    if (isListening) {
      recognition.stop();
    } else {
      setError('');
      recognition.start();
    }
  };

  const handleClearSearch = () => {
    setSearchQuery('');
    setError('');
    localStorage.setItem('SearchHKeyword', '');
  };

  return (
    <div className="keyword-layout">
      <Navbar />
      <SearchNavigation />

      <div className="keyword-main-content">
        <div className="keyword-search-page">
          {/* Hero Section with Gradient */}
          <div className="keyword-hero">
            <div className="hero-badge">
              <i className="bx bx-search-alt-2"></i>
              <span>Keyword Search</span>
            </div>
            <h1 className="hero-title">
              Find exactly what you need—fast and precise
            </h1>
            <p className="hero-subtitle">
              Powerful keyword search with advanced filtering options
            </p>
          </div>

          <div className="keyword-search-container">
            {/* Error Alert */}
            {error && (
              <div className="error-alert">
                <i className="bx bx-error-circle"></i>
                <span>{error}</span>
              </div>
            )}

            {/* Search Card */}
          {/* Search Card */}
<div className="search-card">
  {/* Search Type - Card Style */}
  <div className="search-type-cards">
    <button
      type="button"
      className={`type-card ${searchType === 'exact' ? 'active' : ''}`}
      onClick={() => setSearchType('exact')}
    >
      <div className="card-icon">
        <i className="bx bx-quote-alt-left"></i>
      </div>
      <div className="card-label">Exact Phrase</div>
      <div className="card-description">Match exact words</div>
    </button>

    <button
      type="button"
      className={`type-card ${searchType === 'all' ? 'active' : ''}`}
      onClick={() => setSearchType('all')}
    >
      <div className="card-icon">
        <i className="bx bx-list-ul"></i>
      </div>
      <div className="card-label">All Words</div>
      <div className="card-description">Match all keywords</div>
    </button>

    <button
      type="button"
      className={`type-card near-card ${searchType === 'near' ? 'active' : ''}`}
      onClick={() => setSearchType('near')}
    >
      <div className="card-icon">
        <i className="bx bx-target-lock"></i>
      </div>
      <div className="card-label">Near Words</div>
      <div className="near-input-group">
        <span>Within</span>
        <input
          type="text"
          className="near-input-inline"
          value={nearWordsDistance}
          onChange={(e) => setNearWordsDistance(e.target.value)}
          placeholder="5"
          disabled={searchType !== 'near'}
          onClick={(e) => {
            e.stopPropagation();
            setSearchType('near');
          }}
        />
        <span>words</span>
      </div>
    </button>

    <button
      type="button"
      className={`type-card ${searchType === 'magic' ? 'active' : ''}`}
      onClick={() => setSearchType('magic')}
    >
      <div className="card-icon">
        <i className="bx bx-magic-wand"></i>
      </div>
      <div className="card-label">Intelligent Search</div>
      <div className="card-description">Fast results</div>
    </button>
  </div>

  {/* Search Box */}
  <form onSubmit={handleSearch} className="search-form">
    <div className="search-input-wrapper">
      <input
        type="text"
        className="search-input"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        placeholder="Enter keywords to search..."
        disabled={isLoading}
      />
      <div className="input-actions">
        {searchQuery.length > 0 && (
          <button
            type="button"
            className="action-btn clear-btn"
            onClick={handleClearSearch}
            disabled={isLoading}
            title="Clear"
          >
            <i className="bx bx-x"></i>
          </button>
        )}
        <button
          type="button"
          className={`action-btn voice-btn ${isListening ? 'listening' : ''}`}
          onClick={handleVoiceSearch}
          disabled={isLoading}
          title={isListening ? 'Stop recording' : 'Voice input'}
        >
          <i className={`bx ${isListening ? 'bx-stop-circle' : 'bx-microphone'}`}></i>
        </button>
        <button
          type="submit"
          className="search-submit-btn"
          disabled={isLoading || !searchQuery.trim()}
        >
          {isLoading ? (
            <i className="bx bx-loader-alt bx-spin"></i>
          ) : (
            <i className="bx bx-search"></i>
          )}
        </button>
      </div>
    </div>
  </form>

  {/* Filters Section - Modern Chips Design */}
  <div className="filters-container">
    {/* Sort By - Chip Style */}
    <div className="filter-group">
      <div className="filter-header">
        <i className="bx bx-sort"></i>
        <span>Sort By</span>
      </div>
      <div className="filter-chips">
        <button
          type="button"
          className={`filter-chip ${sortOrder === 'most-relevant' ? 'active' : ''}`}
          onClick={() => setSortOrder('most-relevant')}
        >
          <i className="bx bx-star"></i>
          Most Relevant
        </button>
        <button
          type="button"
          className={`filter-chip ${sortOrder === 'most-recent' ? 'active' : ''}`}
          onClick={() => setSortOrder('most-recent')}
        >
          <i className="bx bx-time"></i>
          Most Recent
        </button>
        <button
          type="button"
          className={`filter-chip ${sortOrder === 'most-referred' ? 'active' : ''}`}
          onClick={() => setSortOrder('most-referred')}
        >
          <i className="bx bx-trending-up"></i>
          Most Referred
        </button>
        <button
          type="button"
          className={`filter-chip ${sortOrder === 'oldest' ? 'active' : ''}`}
          onClick={() => setSortOrder('oldest')}
        >
          <i className="bx bx-history"></i>
          Oldest
        </button>
      </div>
    </div>

    {/* Search In - Toggle Style */}
    <div className="filter-group">
      <div className="filter-header">
        <i className="bx bx-filter"></i>
        <span>Search In</span>
      </div>
      <div className="filter-toggles">
        <button
          type="button"
          className={`toggle-btn ${searchIn === 'H' ? 'active' : ''}`}
          onClick={() => setSearchIn('H')}
        >
          <i className="bx bx-bookmark"></i>
          Head Notes
        </button>
        <button
          type="button"
          className={`toggle-btn ${searchIn === 'F' ? 'active' : ''}`}
          onClick={() => setSearchIn('F')}
        >
          <i className="bx bx-file"></i>
          Full Judgement
        </button>
        <button
          type="button"
          className={`toggle-btn ${searchIn === 'B' ? 'active' : ''}`}
          onClick={() => setSearchIn('B')}
        >
          <i className="bx bx-book-content"></i>
          Both
        </button>
      </div>
    </div>

    {/* Court Selection - Segmented Control */}
    <div className="filter-group">
      <div className="filter-header">
        <i className="bx bx-building"></i>
        <span>Court Selection</span>
      </div>
      <div className="segmented-control">
        <button
          type="button"
          className={`segment ${searchInCourt === 'SC' ? 'active' : ''}`}
          onClick={() => setSearchInCourt('SC')}
        >
          <i className="bx bx-shield"></i>
          Supreme Court
        </button>
        <button
          type="button"
          className={`segment ${searchInCourt === 'ALL' ? 'active' : ''}`}
          onClick={() => setSearchInCourt('ALL')}
        >
          <i className="bx bx-buildings"></i>
          All Courts
        </button>
      </div>
    </div>
  </div>
</div>


          </div>
        </div>
      </div>

   <style>{`
  /* ============================================
     BASE LAYOUT & RESET
  ============================================ */
  body {
    margin: 0 !important;
    padding: 0 !important;
  }

  /* Layout */
  .keyword-layout {
    min-height: 100vh;
    background: #fafafa;
  }

  .keyword-main-content {
    padding-top: 140px; /* Navbar (74px) + SearchNav (66px) */
    width: 100%;
  }

  .keyword-search-page {
    min-height: calc(100vh - 140px);
  }

  /* ============================================
     HERO SECTION
  ============================================ */
  .keyword-hero {
    background: linear-gradient(135deg, #E91E63 0%, #E91E64 25%, #c41849 75%, #D81B60 100%);
    padding: 60px 20px;
    text-align: center;
    color: white;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  }

  .hero-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 24px;
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 50px;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 20px;
  }

  .hero-badge i {
    font-size: 18px;
  }

  .hero-title {
    font-size: 2.5rem;
    font-weight: 800;
    margin: 0 0 12px 0;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    letter-spacing: -0.5px;
    line-height: 1.2;
  }

  .hero-subtitle {
    font-size: 1.1rem;
    opacity: 0.95;
    margin: 0;
    font-weight: 400;
  }

  /* ============================================
     SEARCH CONTAINER
  ============================================ */
  .keyword-search-container {
    max-width: 1100px;
    margin: -40px auto 0;
    padding: 0 20px 60px;
    position: relative;
    z-index: 10;
  }

  /* ============================================
     ERROR ALERT
  ============================================ */
  .error-alert {
    background: linear-gradient(135deg, #fee, #fdd);
    border: 1px solid #fcc;
    color: #c33;
    padding: 14px 20px;
    border-radius: 12px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    box-shadow: 0 2px 8px rgba(220, 53, 69, 0.15);
  }

  .error-alert i {
    font-size: 20px;
    flex-shrink: 0;
  }

  /* ============================================
     SEARCH CARD - MAIN CONTAINER
  ============================================ */
  .search-card {
    background: white;
    border-radius: 24px;
    padding: 35px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  }

  /* ============================================
     SEARCH TYPE CARDS - CREATIVE GRID
  ============================================ */
  .search-type-cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    gap: 15px;
    margin-bottom: 30px;
  }

  .type-card {
    background: linear-gradient(135deg, #fafafa, #f5f5f5);
    border: 2px solid #e0e0e0;
    border-radius: 16px;
    padding: 20px 12px;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    position: relative;
    overflow: hidden;
  }

  .type-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #E91E63, #c41849);
    transform: scaleX(0);
    transition: transform 0.3s ease;
  }

  .type-card:hover {
    transform: translateY(-4px);
    border-color: #E91E63;
    box-shadow: 0 8px 24px rgba(245, 166, 35, 0.2);
  }

  .type-card:hover::before {
    transform: scaleX(1);
  }

  .type-card.active {
    background: linear-gradient(135deg, #E91E63, #c41849);
    border-color: transparent;
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 8px 30px rgba(233, 30, 99, 0.35);
  }

  .type-card.active::before {
    transform: scaleX(1);
    background: rgba(255, 255, 255, 0.5);
  }

  .card-icon {
    width: 48px;
    height: 48px;
    background: linear-gradient(135deg, rgba(245, 166, 35, 0.15), rgba(233, 30, 99, 0.15));
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
    transition: all 0.3s ease;
  }

  .type-card.active .card-icon {
    background: rgba(255, 255, 255, 0.25);
    transform: scale(1.1);
  }

  .card-icon i {
    font-size: 24px;
    color: #E91E63;
    transition: all 0.3s ease;
  }

  .type-card.active .card-icon i {
    color: white;
  }

  .card-label {
    font-size: 15px;
    font-weight: 700;
    color: #333;
    transition: color 0.3s ease;
  }

  .type-card.active .card-label {
    color: white;
  }

  .card-description {
    font-size: 12px;
    color: #666;
    font-weight: 500;
    transition: color 0.3s ease;
  }

  .type-card.active .card-description {
    color: rgba(255, 255, 255, 0.9);
  }

  /* Near Words Input - Inline Style */
  .near-input-group {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: #666;
    margin-top: 4px;
  }

  .type-card.active .near-input-group {
    color: white;
  }

  .near-input-inline {
    width: 45px;
    padding: 4px 8px;
    border: 2px solid #ddd;
    border-radius: 8px;
    text-align: center;
    font-size: 13px;
    font-weight: 700;
    color: #333;
    background: white;
    transition: all 0.2s ease;
  }

  .near-input-inline:focus {
    outline: none;
    border-color: #E91E63;
    box-shadow: 0 0 0 3px rgba(245, 166, 35, 0.15);
  }

  .near-input-inline:disabled {
    background: #f5f5f5;
    color: #999;
    border-color: #e0e0e0;
  }

  .type-card.active .near-input-inline {
    border-color: white;
    background: rgba(255, 255, 255, 0.95);
  }

  /* ============================================
     SEARCH FORM & INPUT
  ============================================ */
  .search-form {
    margin-bottom: 30px;
  }

  .search-input-wrapper {
    display: flex;
    align-items: center;
    gap: 12px;
    background: #fafafa;
    border: 3px solid transparent;
    border-radius: 16px;
    padding: 8px 12px;
    transition: all 0.3s ease;
  }

  .search-input-wrapper:focus-within {
    background: white;
    border-color: #E91E63;
    box-shadow: 0 0 0 4px rgba(245, 166, 35, 0.1);
  }

  .search-input {
    flex: 1;
    border: none;
    background: transparent;
    padding: 12px 8px;
    font-size: 16px;
    color: #333;
    outline: none;
  }

  .search-input::placeholder {
    color: #999;
  }

  .input-actions {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .action-btn {
    width: 44px;
    height: 44px;
    border: none;
    background: white;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #666;
    font-size: 22px;
  }

  .action-btn:hover:not(:disabled) {
    background: linear-gradient(135deg, rgba(245, 166, 35, 0.1), rgba(233, 30, 99, 0.1));
    color: #c41849;
    transform: scale(1.05);
  }

  .action-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .clear-btn i {
    font-size: 28px;
  }

  .voice-btn.listening {
    background: linear-gradient(135deg, #c41849, #D81B60);
    color: white;
    animation: pulse 1.5s infinite;
  }

  .search-submit-btn {
    width: 50px;
    height: 50px;
    border: none;
    background: linear-gradient(135deg, #E91E63, #c41849);
    border-radius: 12px;
    color: white;
    font-size: 24px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 15px rgba(245, 166, 35, 0.3);
  }

  .search-submit-btn:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(233, 30, 99, 0.4);
  }

  .search-submit-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  /* ============================================
     FILTERS CONTAINER - MODERN LAYOUT
  ============================================ */
  .filters-container {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .filter-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .filter-header {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 700;
    color: #555;
    padding-bottom: 8px;
    border-bottom: 2px solid #f0f0f0;
  }

  .filter-header i {
    font-size: 18px;
    color: #E91E63;
  }

  /* ============================================
     FILTER CHIPS - PILL STYLE
  ============================================ */
  .filter-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .filter-chip {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 18px;
    background: #fafafa;
    border: 2px solid #e0e0e0;
    border-radius: 50px;
    font-size: 14px;
    font-weight: 600;
    color: #555;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    white-space: nowrap;
  }

  .filter-chip i {
    font-size: 16px;
    transition: transform 0.3s ease;
  }

  .filter-chip:hover {
    background: linear-gradient(135deg, rgba(245, 166, 35, 0.1), rgba(233, 30, 99, 0.05));
    border-color: #E91E63;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(245, 166, 35, 0.2);
  }

  .filter-chip.active {
    background: linear-gradient(135deg, #E91E63, #c41849);
    border-color: transparent;
    color: white;
    box-shadow: 0 4px 16px rgba(233, 30, 99, 0.3);
  }

  .filter-chip.active i {
    transform: scale(1.15);
  }

  /* ============================================
     TOGGLE BUTTONS - MODERN TOGGLE STYLE
  ============================================ */
  .filter-toggles {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
  }

  .toggle-btn {
    flex: 1;
    min-width: 140px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 14px 20px;
    background: white;
    border: 2px solid #e0e0e0;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
    color: #555;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
  }

  .toggle-btn::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background: linear-gradient(180deg, #E91E63, #c41849);
    transform: scaleY(0);
    transition: transform 0.3s ease;
  }

  .toggle-btn:hover {
    background: #fafafa;
    border-color: #E91E63;
    transform: translateX(2px);
  }

  .toggle-btn:hover::before {
    transform: scaleY(1);
  }

  .toggle-btn.active {
    background: linear-gradient(135deg, rgba(245, 166, 35, 0.15), rgba(233, 30, 99, 0.1));
    border-color: #c41849;
    color: #c41849;
  }

  .toggle-btn.active::before {
    transform: scaleY(1);
  }

  .toggle-btn i {
    font-size: 18px;
  }

  /* ============================================
     SEGMENTED CONTROL - iOS STYLE
  ============================================ */
  .segmented-control {
    display: flex;
    background: #f0f0f0;
    border-radius: 12px;
    padding: 4px;
    gap: 4px;
  }

  .segment {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 20px;
    background: transparent;
    border: none;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 600;
    color: #666;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .segment i {
    font-size: 18px;
  }

  .segment:hover {
    background: rgba(245, 166, 35, 0.1);
    color: #E91E63;
  }

  .segment.active {
    background: white;
    color: #c41849;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  /* ============================================
     ANIMATIONS
  ============================================ */
  @keyframes pulse {
    0%, 100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.05);
    }
  }

  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  .bx-spin {
    animation: spin 1s linear infinite;
  }

  /* ============================================
     RESPONSIVE DESIGN - TABLET
  ============================================ */
  @media (max-width: 1024px) {
    .hero-title {
      font-size: 2rem;
    }

    .keyword-search-container {
      max-width: 900px;
    }

    .search-type-cards {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  /* ============================================
     RESPONSIVE DESIGN - MOBILE
  ============================================ */
  @media (max-width: 768px) {
    .keyword-main-content {
      padding-top: 130px;
    }

    .keyword-hero {
      padding: 40px 15px;
    }

    .hero-title {
      font-size: 1.5rem;
    }

    .hero-subtitle {
      font-size: 0.95rem;
    }

    .keyword-search-container {
      margin-top: -30px;
      padding: 0 15px 40px;
    }

    .search-card {
      padding: 20px;
    }

    .search-type-cards {
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;
    }

    .type-card {
      padding: 16px 10px;
    }

    .card-icon {
      width: 40px;
      height: 40px;
    }

    .card-icon i {
      font-size: 20px;
    }

    .card-label {
      font-size: 13px;
    }

    .card-description {
      font-size: 11px;
    }

    .search-input {
      font-size: 14px;
      padding: 10px 6px;
    }

    .action-btn {
      width: 40px;
      height: 40px;
      font-size: 20px;
    }

    .search-submit-btn {
      width: 46px;
      height: 46px;
      font-size: 22px;
    }

    .filter-chips {
      gap: 8px;
    }

    .filter-chip {
      padding: 8px 14px;
      font-size: 13px;
    }

    .toggle-btn {
      min-width: 120px;
      padding: 12px 16px;
      font-size: 13px;
    }

    .segment {
      padding: 10px 16px;
      font-size: 13px;
    }
  }

  /* ============================================
     RESPONSIVE DESIGN - SMALL MOBILE
  ============================================ */
  @media (max-width: 575.98px) {
    .hero-title {
      font-size: 1.3rem;
    }

    .hero-badge {
      padding: 8px 16px;
      font-size: 13px;
    }

    .search-card {
      padding: 15px;
    }

    .search-type-cards {
      grid-template-columns: 1fr;
      gap: 8px;
    }

    .type-card {
      padding: 14px 10px;
    }

    .filter-chips {
      gap: 8px;
    }

    .filter-chip {
      padding: 6px 12px;
      font-size: 13px;
    }

    .filter-toggles {
      flex-direction: column;
    }

    .toggle-btn {
      min-width: 100%;
    }

    .segment {
      font-size: 12px;
      padding: 10px 12px;
    }
  }

  /* ============================================
     EXTRA SMALL SCREENS
  ============================================ */
  @media (max-width: 480px) {
    .search-type-cards {
      grid-template-columns: 1fr;
    }

    .filter-header {
      font-size: 13px;
    }

    .filter-header i {
      font-size: 16px;
    }
  }
`}</style>
    </div>
  );
};

export default Keyword;